export interface TenantContaResponse {
  id: string;
  nome: string;
  padrao: boolean;
  imagemUrl: string;
  saldo: number;
  saldoInicial: number;
  dataSaldoInicial: string;
  tipo: TipoTenantContaEnum;
  agenciaDigito: string;
  contaDigito: string;
  bancoId: string;
  banco: { nome: string; id: string; emiteBoleto: boolean };
  documento: string;
  bancoCodigo: string;
  agencia: string;
  numero: string;

  emiteBoleto: boolean;
  convenio: string;

  bancoEspecieDocId: string;
  bancoEspecieDoc: string;

  inicioSequenciaRemessa: number;

  bancoCarteiraId: string;
  bancoCarteira: string;
  cnab: number;
  range: string;
  byte: string;
  posto: string;
  codigoCliente: string;
  variacaoCarteira: string;
  ativo: boolean;

  codigoIntegracao?: string;
  ativarPagamentoOnline?: boolean;
  desabilitadaAdmin?: boolean;
}

export interface CarteirasResponse {
  id: string;
  nome: string;
}

export interface EspeciesDocResponse {
  id: string;
  nome: string;
  sigla: string;
  codigo: string;
}

export enum TipoTenantContaEnum {
  ContaCorrente = "corrente",
  CaixaFisico = "caixa-fisico",
}
